module.exports = __webpack_public_path__ + "img/apple-profile.93e9aeab.jpg";